import { Dialog, Transition } from '@headlessui/react';
import React, { useState } from 'react';
import { Fragment } from 'react';
import { getAuthorizationHeader, http } from '../../config/http';
import { toast } from 'react-toastify';
import useBarangTerhapus from '../features/useBarangTerhapus';
import LoadingIndicator from '../../components/LoadingIndicator';

export default function RestoreBarang({
    isOpenModalRestore,
    closeModalRestore,
    reloadData,
    selectedIds
}) {

    const [loading, setLoading] = useState();
    const handleSubmitBarangRestore = async () => {
        setLoading(true)
        const data = { items: selectedIds }
        await http.post(`/trash/restore`, data, {
            headers: { Authorization: getAuthorizationHeader() },
        }).then((res) => {
            toast.success('Data berhasil dipulihkan', { autoClose: 600, });
            closeModalRestore();
            reloadData();
            // console.log(res.data)
        }).catch((err) => {
            if (err.response.status === 400) {
                toast.error('Pastikan telah memilih barang yang akan direstore', { autoClose: 600, })
            }
            console.log(err)
        })
        setLoading(false)
    }
    return (
        <>
            {loading && <LoadingIndicator />}
            <Transition appear show={isOpenModalRestore} as={Fragment}>
                <Dialog as="div" className="relative z-10" onClose={() => { }}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black bg-opacity-25" />
                    </Transition.Child>
                    <div className="fixed inset-0 overflow-y-auto">
                        <div className="flex items-center justify-center p-4 min-h-[440px]">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel className={`w-full max-w-[30rem] transform overflow-hidden bg-white p-2 print:border text-left align-middle shadow-xl print:shadow-none transition-all`}>
                                    <h2 className='text-lg font-semibold border-b'>Restore Barang</h2>
                                    <div>
                                        Apakah anda yakin untuk mengembalikan barang ini lagi?
                                    </div>

                                    <div className='flex w-full gap-1 justify-end'>
                                        <button className='mt-2 bg-slate-700 text-white px-3 py-2' onClick={closeModalRestore}>
                                            Tutup
                                        </button>
                                        <button disabled={loading} className='mt-2 bg-green-500 text-white px-3 py-2' onClick={handleSubmitBarangRestore}>
                                            {`${loading ? 'Proses ...' : 'Restore'}`}
                                        </button>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </>
    );
}
